module.exports = __webpack_public_path__ + "img/nav-advice.ac16d6e.jpg";